import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const MODULE_ROUTES = {
  dairy: '/dairy',
  chemicals: '/chemicals',
  agriculture: '/agriculture',
  adhesive: '/adhesive',
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        color: '#666',
        fontFamily: "'Inter', sans-serif"
      }}>
        Loading...
      </div>
    );
  }

  // Not logged in → go to login
  if (!user) return <Navigate to="/login" />;

  // Operator trying to access main dashboard → redirect to their module
  if (user.role === 'operator' && allowedRoles && !allowedRoles.includes('operator')) {
    const route = MODULE_ROUTES[user.business_module] || '/dairy';
    return <Navigate to={route} />;
  }

  return children;
};

export default ProtectedRoute;